import React, { Component } from 'react';
import $ from 'jquery';

import AdminLayout from './layout';

import FetchCall from '../../API/FetchCall';
import { getMail, uploadEditorImage } from '../../API/FetchCall';
//import { Editor } from '@tinymce/tinymce-react';

import { getArticleDetail, getBlogCategory, updateInsights, getAuthorSuggest, uploadArticleImage,  commonAPI, approveInsight } from '../../API/FetchCall';
import Autosuggest from 'react-autosuggest';

import { EditorState, convertToRaw, convertFromHTML, convertFromRaw, ContentState } from 'draft-js';
//import { Editor } from 'react-draft-wysiwyg';
import '../../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import draftToHtml from 'draftjs-to-html';

import { Editor } from '@tinymce/tinymce-react';
import { TINY_EDITOR, REACT_APP_API_PATH } from '../../constant';

import axios from 'axios';

import 'react-notifications/lib/notifications.css';
import {NotificationContainer, NotificationManager} from 'react-notifications';

class cmsAddEditInsight extends Component {

    constructor(props) {
        super(props);
        this.state = {
          logged: localStorage.getItem("authentication"),
          auth_data: JSON.parse(localStorage.getItem("user_data")),
          write_permission: true,
          insight_id: 0,
          insight_title: '',
          insight_desc: '',
          banner_image: '',
          banner_new: '',
          gallery_image: '',
          article_images: '',
          show_upload: false,
          articleuploaded: false,
          gallery_new: '',
          insight_content: '',
          insight_author: '',
          about_author: '',
          related_vertical:'',
          social_links: [{ id: "fb", name: 'Facebook', link: "" }, { id: "li", name: 'LinkedIn', link: "" },
          { id: "in", name: 'Instagram', link: "" }, { id: "tw", name: 'Twitter', link: "" }],
          imageList: [],
          suggestions: [],
          location: [],
          locationList: [],
          categorylist:[],
          bewisecategorylist:[],
          btnDisable: false,
          category:'',
          featured:0,
          editorState: EditorState.createEmpty()
        };
         this.getLocation();
         this.handleEditorChange = this.handleEditorChange.bind(this);
         this.approveBlog = this.approveBlog.bind(this);
        this.id = this.props.match.params.id ? this.props.match.params.id : '';
    }


    componentDidMount() {

      var THIS = this;
      
      if(this.id!='')
      this.getInsightDetail(this.id);

      this.getBlogCategory();
      this.getBlogBeWiseCategory();
      

    }

 
 handleEditorChange(value, editor) {
    this.setState({
      insight_content: value
    });
  }
 

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };
  handleCheck = (e) => {
    this.setState((prevState) => ({
      show_upload: !prevState.show_upload,
    }));
  };
  customChange = (e, i) => {
    let social_links = this.state.social_links;
    if (social_links.length > 0 && social_links[i]) {
      social_links[i].link = e.target.value;
    }
    this.setState({ social_links });
  };
  handleFile = (e) => {
    const propName = e.target.name;
    const files = e.target.files[0];
    this.setState({
      [propName]: files
    });
  };

  uploadImageCallBack = (e) => {
    const propName = e.target.name;
    var files = e.target.files;
    this.setState({
      [propName]: files
    });
  };

  handleFileMultiple = (e) => {
    const propName = e.target.name;
    var files = e.target.files;
    if (files.length > 2) {
      files = '';
      let toastr = window.toastr.error; //warning
      toastr('', 'Select Article 2 Images Only', {
        positionClass: "toast-bottom-right",
        containerId: "toast-bottom-right"
      });
    }
    this.setState({
      [propName]: files
    });
  };
  handleSelect = (e) => {
    const propName = e.target.name;
    const value = [...e.target.selectedOptions].map((item) => item.value);
    this.setState({ [propName]: value });
  }

    getInsightDetail = () => {
      let ins = JSON.stringify({
        id:this.id
      });
      getArticleDetail(ins).then((res) => {
        if (res.status == 1) {
          var data = res.detail;
          this.setState({
          insight_id:data.insight_id,
          insight_title: data.title,
          related_vertical:data.related_vertical,
          slug_term:data.slug_term,
          authorname:data.authorname,
          category:data.category,
          insight_desc: data.main_content,
          social_links: data.social_links ? JSON.parse(data.social_links) : this.state.social_links,
          banner_image: data.banner_image ? res.base_url + data.banner_image : '',
          banner_new: '',
          gallery_image: data.gallery_image ? res.base_url + data.gallery_image : '',
          gallery_new: '',
          related_vertical:data.related_vertical,
          about_author: data.about_author,
          location: data.location ? data.location.split(',') : [],
          insight_content: data.detail_content,
          insight_author: data.author_name,
          status:data.status,
          editorState:EditorState.createWithContent(ContentState.createFromBlockArray(convertFromHTML(res.detail.detail_content)))
            
          });

          this.setState({ 
            consigne:EditorState.createWithContent(ContentState.createFromBlockArray(convertFromHTML(res.detail.detail_content))) 
          })

        } else {
          this.setState({
            insightDetail: '',
          });
        }
      });
    }    

  escapeRegexCharacters(str) {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }
  onSuggestionsFetchRequested = ({ value }) => {
    console.log('came first ', value);
    const val = this.escapeRegexCharacters(value.trim());
    let fetch = JSON.stringify({
      keyword: val,
      role: 1
    });
    getAuthorSuggest(fetch).then(res => {
      if (res.status == 1) {
        this.setState({
          suggestions: res.list
        });
      }
    });
  };

  onSuggestionsClearRequested = () => {
    this.setState({
      suggestions: []
    });
  };

  onSuggestionSelected = (event, { suggestion, suggestionValue, suggestionIndex, sectionIndex, method } ) => {
    $("#vendor_id").val(suggestion.vendor_id);
    //alert(suggestion.vendor_id);
    this.setState({
        login_id: suggestion.vendor_id
    });
  };


  getSuggestionValue = (suggestion) => {
    return suggestion.name;
  }

  renderSuggestion(suggestion) {
    return (
      <span>{suggestion.name}</span>
    );
  }
  onChange = (event, { newValue, method }) => {
    this.setState({
      insight_author: newValue
    });
  };

  getLocation = () => {
    let req = JSON.stringify({
      url: 'location_list'
    });
    commonAPI(req).then(res => {
      if (res.status === 1) {
        this.setState({
          locationList: res.list
        })
      }
    })
  }

  getBlogCategory = () => {
    let req = JSON.stringify({
      site: 'wiseconnect'
    });
    getBlogCategory(req).then(res => {
      if (res.status === 1) {
        this.setState({
          categorylist: res.list
        })
      }
      else{
        this.setState({
          categorylist: []
        })
      }
    })
  }

  getBlogBeWiseCategory = () => {
    let req = JSON.stringify({
      site: 'bewise'
    });
    getBlogCategory(req).then(res => {
      if (res.status === 1) {
        this.setState({
          bewisecategorylist: res.list
        })
      }
      else{
        this.setState({
          bewisecategorylist: []
        })
      }
    })
  }
  

  approveBlog  = (e) => {


    let insert =  JSON.stringify({
      insight_id: this.state.insight_id,
      status :1
    });
    
    approveInsight(insert).then((response) => {
      this.setState({
        btnDisable: false
      })
      if (response.status == 1) {
         
         NotificationManager.success('Insight is approved successfully..redirecting to list');

         window.location.href='/cms/insights';
         //alert("Insight is added");
      }
  });

  }


  handleSubmit = (e) => {


      let insert = {
        insight_id: this.state.insight_id,
        insight_title: this.state.insight_title,
        insight_desc: this.state.insight_desc,
        slug_term:this.state.slug_term,
        about_author: this.state.about_author,
        related_vertical:this.state.related_vertical,
        location: this.state.location,
        insight_content: this.state.insight_content,
        social_links: JSON.stringify(this.state.social_links),
        insight_author: this.state.insight_author,
        category:this.state.category,
        featured:this.state.featured,
        banner_new: this.state.banner_new,
        gallery_new: this.state.gallery_new
      }
      updateInsights(insert).then((response) => {
        this.setState({
          btnDisable: false
        })
        if (response.status == 1) {
           if(this.state.insight_id=='')
           NotificationManager.success('Insight is added successfully..redirecting to list');
           else
           NotificationManager.success('Insight is updated successfully..redirecting to list');

           window.location.href='/cms/insights';
           //alert("Insight is added");
        } else {
           //alert("Issue in adding insight");
           NotificationManager.success('Insight is added successfully..redirecting to list');
        }
      });
 

  }

  onChangeEditor = (editorState) => {
    //const contentState = editorState.getCurrentContent();
    //console.log("plain text", editorState.getCurrentContent().getPlainText());

    const contentState = draftToHtml(convertToRaw(editorState.getCurrentContent()))

    console.log("html", contentState);
    //const raw = convertToRaw(contentState);
    this.setState({
      consigne:editorState,
      insight_content:contentState
    });
  }

    render() {

        const { insightDetail } = this.state;
        const { categorylist, suggestions, bewisecategorylist } = this.state;
        const inputProps = {
          value: this.state.insight_author,
          onChange: this.onChange,
          name: 'insight_author',
          className: 'form-control'
        };

        const { insight_content, editorState, consigne} = this.state;
        const { login_id, role } = this.state.auth_data;

        return (
            <React.Fragment>
                <AdminLayout>
                    
             <div class="col-12 grid-margin">
              <div class="card">
                <div class="card-body">
                  <h4 class="card-title">Insights - Add/Edit</h4>
                    

                   <div>
                      <div className="row">
                        <div class="form-group col-md-3">
                          <label> Title <span className="astrick">*</span></label>
                        </div>
                        <div class="form-group col-md-9">
                          <input name='insight_title' className='form-control' type='text' value={this.state.insight_title}
                            onChange={this.handleChange} />
                          
                        </div>
                      </div>

                      <div className="row">
                        <div class="form-group col-md-3">
                          <label> Preferred URL (Never use special characaters as *,@,#,/,+,- and etc, except hyphen(-))</label>
                        </div>
                        <div class="form-group col-md-9">
                          <input name='slug_term' className='form-control' type='text' value={this.state.slug_term}
                            onChange={this.handleChange} />
                          
                        </div>
                      </div>


                      <div className="row">
                        <div class="form-group col-md-3">
                          <label> Description <span className="astrick">*</span></label>
                        </div>
                        <div class="form-group col-md-9">
                          <textarea name='insight_desc' className='form-control' rows={3} value={this.state.insight_desc}
                            onChange={this.handleChange} />
                          
                        </div>
                      </div>
                      

                      <div className="row">
                        <div class="form-group col-md-3">
                          <label> Blog related to <span className="astrick">*</span></label>
                        </div>
                        <div class="form-group col-md-9">
                          <select class="form-control" name="related_vertical" value={this.state.related_vertical}  onChange={this.handleChange} >
                            
                              <option value="">Select</option>
                              <option value="tuitionblogs">Tuition Blogs</option>
                              <option value="schoolblogs">School Blogs</option>
                              <option value="preschoolblogs">Preschool Blogs</option>
                              <option value="danceblogs">Dance Blogs</option>
                              <option value="sportsblogs">Sports Blogs</option>
                              <option value="musicblogs">Music Blogs</option>
                              <option value="artblogs">Art Blogs</option>
                              <option value="hobbiesblogs">Hobbies Blogs</option>
                              <option value="wiseconnectblogs">WiseConnect Blogs</option>
                          </select>
                        </div>
                      </div>

                      {this.state.related_vertical=='wiseconnectblogs' && 
                        <div className="row">
                        <div class="form-group col-md-3">
                          <label> Choose Category <span className="astrick">*</span></label>
                        </div>
                        <div class="form-group col-md-9">
                          <select class="form-control" name="category" value={this.state.category}  onChange={this.handleChange} >
                            
                              <option value="">Select</option>
                              {categorylist.map((item, index)=>{

                                return <option value={item.id}>{item.name}</option>
                              })}
                               
                              
                          </select>
                        </div>
                        </div> 
                      }  

                    {this.state.related_vertical!='wiseconnectblogs' && 
                        <div className="row">
                        <div class="form-group col-md-3">
                          <label> Choose Category <span className="astrick">*</span></label>
                        </div>
                        <div class="form-group col-md-9">
                          <select class="form-control" name="category" value={this.state.category}  onChange={this.handleChange} >
                            
                              <option value="">Select</option>
                              {bewisecategorylist.map((item, index)=>{

                                return <option value={item.id}>{item.name}</option>
                              })}
                               
                              
                          </select>
                        </div>
                        </div> 
                      }  
 
                      {this.state.related_vertical=='wiseconnectblogs' && 
                        <div className="row">
                        <div class="form-group col-md-3">
                          <label> Want to make featured </label>
                        </div>
                        <div class="form-group col-md-9 flexoption">
                            <input type="radio" name="featured" value="1" onChange={this.handleChange}/> Yes&nbsp;
                            <input type="radio" name="featured" value="0" onChange={this.handleChange} checked/> No 
                        </div>
                        </div> 
                      }  
 
                      
                      <div className="row">
                        <div class="form-group col-md-3">
                          <label> Blog Banner Image <span className="astrick">* (prefer .webp format) </span></label>
                        </div>
                        <div class="form-group col-md-9">

                       
                          <input
                            type="file"
                            name="gallery_new"
                            onChange={this.handleFile}
                            className="form-control mar-btm"
                            accept="image/x-png,image/gif,image/jpeg"
                          />

                       
                        </div>
                        
                      </div>
                      <div className="row">
                        <div class="form-group col-md-3">
                          <label> Author Name <span className="astrick">*</span></label>
                        </div>
                        <div class="form-group col-md-9">

                        
                        
                          <Autosuggest
                            suggestions={suggestions}
                            onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                            onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                            getSuggestionValue={this.getSuggestionValue}
                            renderSuggestion={this.renderSuggestion}
                            inputProps={inputProps} />
                         
                        </div>
                      </div>
                      
                      
                     
                      <div className="row" style={{ marginBottom: '30px' }}>
                        <div class="form-group col-md-3">
                          <label> Content <span className="astrick">*</span></label>
                        </div>
                        <div class="form-group col-md-9">

                          <Editor
                            onEditorChange={this.handleEditorChange}
                            toolbar={{
                                inline: { inDropdown: true },
                                list: { inDropdown: true },
                                textAlign: { inDropdown: true },
                                link: { inDropdown: true },
                                history: { inDropdown: true },
                                image: { uploadCallback: this.uploadImageCallBack, alt: { present: true, mandatory: true } },
                              }}
                            value={this.state.insight_content}
                            name="insight_content"
                            apiKey={TINY_EDITOR}
                            init={{
                                  height: 300,
                                  theme:"silver",
                                  plugins: ["advlist autolink lists link anchor paste image"],
                                  file_picker_types: "file image media",
                                  toolbar: 'undo redo | formatselect | image| bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | help',
                                  //images_upload_handler: uploadImageCallBackServer
                                  images_upload_handler: async function(
                                                                          blobInfo:any,
                                                                          success: any,
                                                                          failure: any
                                                                        ) {
                                                                          let imageFile = new FormData();
                                                                          //imageFile.append("files[]", blobInfo.blob());
                                                                          imageFile.append('image', blobInfo.blob());
                                                                          try {
                                                                            const {data} = await axios.post(REACT_APP_API_PATH+"az/uploadeditorimage", imageFile)
                                                                            success(data.data.link);
                                                                          } catch (error) {
                                                                            console.log(error);
                                                                            return;
                                                                          }
                                                                        }
                            }}
                   
                          />

                          { /* 
                           <Editor
                            handlePastedText={() => false}
                            value={draftToHtml(convertToRaw(editorState.getCurrentContent()))}
                            editorState={consigne}
                            toolbarClassName="toolbarClassName"
                            wrapperClassName="wrapperClassName"
                            editorClassName="editorClassName"
                            onEditorStateChange={this.onChangeEditor.bind(this)}
                            
                            toolbar={{
                              image: {
                              previewImage: true,
                              uploadCallback: uploadImageCallBack,
                              alt: { present: true, mandatory: false },
                              },
                            }}
                          /> */ 
                          }
                        </div>
                      </div>

                       
                      <div className="row">
                        <div class="form-group col-md-3">
                          <label> Location <span className="astrick">*</span></label>
                        </div>
                        <div class="form-group col-md-9">
                          <select className='form-control selectpicker' name='location' value={this.state.location}
                            onChange={this.handleSelect} multiple data-live-search="true"
                            data-actions-box="true">
                            {this.state.locationList.map((item, i) => {
                              return (
                                <option value={item.id}>{item.location}</option>
                              )
                            })}
                          </select>
                           

                        </div>
                      </div>
                       
                     
                      <div className="row mb-4 text-right">
                        <button type='submit' id="btnSubmit"
                          className="btn btn-primary btn-sm" onClick={this.handleSubmit} disabled={this.state.btnDisable} style={{ display: "block", margin: "auto" }}>
                          Submit
                        </button>
                      </div>
                      

                      {this.state.status==0 && login_id==1 && (
                        <div className="row mb-4 text-right">
                          <button type='submit' id="btnSubmit" onClick={this.approveBlog}
                            className="btn btn-primary btn-sm" style={{ display: "block", margin: "auto" }}>
                            Approve
                          </button>
                        </div>
                      )}

                    </div>


                  

                </div>
              </div>
            </div>  
            <NotificationContainer/>

                </AdminLayout>
            </React.Fragment>
        )
    }
}

/*
function uploadImageCallBackServer(file) {
  return new Promise(
    (resolve, reject) => {
      const reader = new window.FileReader();
      const xhr = new XMLHttpRequest(); // eslint-disable-line no-undef
      //xhr.open('POST', 'https://api.bewise.in/api/campaign/mail/uploadeditorimage');
      xhr.open('POST', 'https://api.bewise.in/api/campaign/mail/uploadeditorimage');
      xhr.setRequestHeader('x-auth-token', 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ2ZW5kZXIiOnsiaWQiOiI1ZWJkMTMyOTQwMjJhMjNlMmM1YzA4MzkifSwiaWF0IjoxNTkxMTgwOTA3LCJleHAiOjM2MDAwMDAwMDAxNTkxMTgwMDAwfQ.TKBUep0bss3gqQBK8CkbUuRlO3jRLHEvGTGgm90gLRE');
      const data = new FormData(); // eslint-disable-line no-undef
      data.append('image', file);
      xhr.send(data);
      xhr.addEventListener('load', () => {
        const response = JSON.parse(xhr.responseText);
        resolve(response);
      });
      xhr.addEventListener('error', () => {
        const error = JSON.parse(xhr.responseText);
        reject(error);
      });
    },
  );
}
*/

export default cmsAddEditInsight;


// WEBPACK FOOTER //
// ./src/components/bewise/cmsAddEditInsight.jsx